export default "__VITE_ASSET__aee682f7__"